(function(){
  var storageKey='dogmeFreeShippingClosed';

  function formatMoney(cents,currency){
    var amount=Math.max(0,cents)/100;
    try{return new Intl.NumberFormat('ja-JP',{style:'currency',currency:currency||'JPY',maximumFractionDigits:0}).format(amount)}
    catch(error){return '¥'+Math.round(amount).toLocaleString('ja-JP')}
  }

  function updateNotice(notice,subtotal){
    var threshold=parseInt(notice.getAttribute('data-threshold-cents'),10)||700000;
    var success=notice.getAttribute('data-success-message')||'送料無料の対象です';
    var currency=notice.getAttribute('data-currency')||'JPY';
    var remaining=threshold-subtotal;
    var percent=Math.min(100,Math.max(0,Math.round(subtotal*100/threshold)));
    var status=notice.querySelector('[data-free-shipping-status]');
    var bar=notice.querySelector('[data-free-shipping-bar]');
    var track=notice.querySelector('[role="progressbar"]');

    if(status){
      if(remaining<=0)status.textContent=success;
      else if(subtotal>0)status.textContent='送料無料まであと'+formatMoney(remaining,currency);
      else status.textContent='お買い物をお楽しみください';
    }
    if(bar)bar.style.width=percent+'%';
    if(track)track.setAttribute('aria-valuenow',String(percent));
  }

  function initialise(){
    var notices=Array.prototype.slice.call(document.querySelectorAll('[data-dogme-free-shipping]'));
    if(!notices.length)return;

    notices.forEach(function(notice){
      var close=notice.querySelector('[data-free-shipping-close]');
      if(notice.getAttribute('data-mode')==='floating'){
        try{if(window.sessionStorage.getItem(storageKey)==='1')notice.hidden=true}catch(error){}
      }
      if(close)close.addEventListener('click',function(event){
        event.preventDefault();
        notice.hidden=true;
        try{window.sessionStorage.setItem(storageKey,'1')}catch(error){}
      });
      updateNotice(notice,parseInt(notice.getAttribute('data-subtotal-cents'),10)||0);
    });

    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    fetch(root+'cart.js',{credentials:'same-origin'})
      .then(function(response){if(!response.ok)throw new Error('Cart request failed');return response.json()})
      .then(function(cart){var subtotal=cart.items_subtotal_price||cart.total_price||0;notices.forEach(function(notice){updateNotice(notice,subtotal)})})
      .catch(function(){});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise);
  else initialise();
})();
